/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/ObservationPanel.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Displays observations created during work execution.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Display observations
 * ✓ Add new observation
 * ✓ Edit observation (future)
 * ✓ Delete observation (future)
 *
 ******************************************************************************/

import React from "react";

export default function ObservationPanel({

    observations = [],

    disabled = false,

    onAdd,

    onView,

}) {

    return (

        <div className="card shadow-sm border-0 mb-4">

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <div className="card-header bg-white">

                <div className="d-flex justify-content-between align-items-center">

                    <div>

                        <h5 className="mb-0">

                            Observations

                        </h5>

                    </div>

                    <button

                        className="btn btn-primary btn-sm"

                        disabled={disabled}

                        onClick={onAdd}

                    >

                        <i className="fas fa-plus me-2" />

                        Add Observation

                    </button>

                </div>

            </div>

            {/* ====================================================== */}
            {/* BODY */}
            {/* ====================================================== */}

            <div className="table-responsive">

                <table className="table table-hover mb-0 align-middle">

                    <thead className="table-light">

                        <tr>

                            <th width="80">

                                #

                            </th>

                            <th>

                                Type

                            </th>

                            <th>

                                Description

                            </th>

                            <th>

                                Created By

                            </th>

                            <th>

                                Created On

                            </th>

                            <th className="text-end">

                                Action

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            observations.length === 0 && (

                                <tr>

                                    <td
                                        colSpan="6"
                                        className="text-center py-4 text-muted"
                                    >

                                        No observations available.

                                    </td>

                                </tr>

                            )

                        }

                        {

                            observations.map((row, index) => (

                                <tr key={row.id}>

                                    <td>

                                        {index + 1}

                                    </td>

                                    <td>

                                        <span className="badge bg-warning text-dark">

                                            {row.type}

                                        </span>

                                    </td>

                                    <td>

                                        {row.description}

                                    </td>

                                    <td>

                                        {row.created_by}

                                    </td>

                                    <td>

                                        {row.created_at}

                                    </td>

                                    <td className="text-end">

                                        <button

                                            className="btn btn-outline-primary btn-sm"

                                            onClick={() =>

                                                onView?.(row)

                                            }

                                        >

                                            View

                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}